import {Component, OnInit} from '@angular/core';
import {LoginInfoComponent} from "../../user/login-info/login-info.component";
import {Observable} from "rxjs/Observable";
import {jcService} from "../../jc-services/jc-services.service";


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  menuItems: Observable<any>;

  items = ['Assembly 1', 'Assembly 2', 'Body Weld', 'Paint 1', 'Paint 2', 'Powertrain', 'Stamping'];
  myItems = this.items[0];

  constructor(private jcService: jcService) {
  }

  ngOnInit() {

      this.menuItems = this.jcService.getZones();
  }

}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/layout/navigation/navigation.component.ts